import { defaultState as defaultStateForResultsByCountReducer } from "./resultsByCount";
const values = Object.values(defaultStateForResultsByCountReducer);
const length = values.length;
const defaultValueForSlider = length > 4 ? [1, length - 2] : [0, 0];
const shouldShowSlider = !!length;

export const defaultState = {
  min: 0,
  max: values.length - 1,
  defaultValue: defaultValueForSlider,
  shouldShowSlider
};

const slider = (state = defaultState, action) => {
  switch (action.type) {
    case "FETCH_HASHTAGS_SUCCESS":
      const max = action.groups.length - 1;
      return {
        ...state,
        max,
        defaultValue: [1, max - 1],
        shouldShowSlider: action.shouldShowSlider
      };
    case "CHANGE_SLIDER":
      return {
        ...state,
        defaultValue: action.defaultValue
      };
    default:
      return state;
  }
};

export default slider;



// WEBPACK FOOTER //
// ./src/reducers/slider.js